import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
export const publicBrevoContract = c.router(
  {
    processWebhook: {
      method: 'POST',
      path: '/process-webhook',
      body: z.any(),
      responses: {
        200: z.string(),
      },
      summary: 'Webhook called by Brevo',
    },
  },
  {
    pathPrefix: '/public',
  },
);
